import type { QuestCategory } from './types';

export const QUEST_CATEGORY_MAP: Record<number, QuestCategory> = {
  8: "daily",                                        // adsgram interstitial quest
  41: "daily",                                       // hourly (watch ad)
  139: "mayor",                                      // daily election vote → mayor tab
  1: "daily", 2: "daily", 3: "daily",              // exploration quests → daily
  4: "daily", 5: "daily", 106: "daily", 107: "daily",
  205: "daily", 206: "daily", 207: "daily",        // furniture, cobweb, duel wins
  6: "social",  108: "social",                       // social media (Telegram/X)
  172: "social", 200: "social",                    // write to bot, invite friends
  7: "partner", 208: "partner", 209: "partner",    // partner quests
  140: "mayor", 141: "mayor",                      // mayor elections
  210: "mayor",                                     // talk to mayor
};

// Dynamic category resolver: uses QUEST_CATEGORY_MAP first, then falls back to objective type
export const getQuestCategory = (q: { questId: number; objectives?: { type: string }[] }): QuestCategory | undefined => {
  const mapped = QUEST_CATEGORY_MAP[q.questId];
  if (mapped) return mapped;
  // Fallback: categorize by objective type for dynamically-created quests
  const objType = q.objectives?.[0]?.type;
  if (objType === "talk_to_mayor") return "mayor";
  return undefined;
};
